import React from 'react';
import { SelectInputProps } from './types';
import TSelectInput, { SelectInputAnalytics } from './SelectInput';

const SelectInput: React.FC<SelectInputProps> = ({
  trackId,
  trackCategory,
  trackedHandlers,
  untrackedHandlers,
  stopTracking,
  canReturnParams,
  ...rest
}) => {
  if (trackId) {
    return (
      <SelectInputAnalytics
        trackId={trackId}
        trackCategory={trackCategory}
        trackedHandlers={trackedHandlers}
        untrackedHandlers={untrackedHandlers}
        stopTracking={stopTracking}
        canReturnParams={canReturnParams}
        {...rest}
      />
    );
  }
  return <TSelectInput {...rest} />;
};

export default SelectInput;
